import { createContext } from 'react';

import { HVACSpace } from '@totem/components/portfolio/buildings/hvac/types';

interface Context {
  loading: boolean;
  data: HVACSpace[];
  buildingId: string;
  requestRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  data: [],
  buildingId: '',
  requestRefresh: () => {},
});
